import React from 'react';
import { FiUpload, /* FiTrash2, */ FiDownload, FiEye } from 'react-icons/fi';

export function ContactFilesCard({ files, normalizeType, formatSize, TypeIcon, onPreview, onDownload, onEdit, /* onDelete, */ onUploadClick }) {
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Associated Files</h5>
        <button className="btn btn-sm btn-primary" onClick={onUploadClick}>
          <FiUpload className="me-1" /> Upload
        </button>
      </div>
      <div className="card-body">
        {(!files || files.length === 0) ? (
          <div className="text-muted">No files associated with this contact.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th className="text-end">Size</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {files.map((f) => {
                  const type = normalizeType(f.fileType, f.fileName);
                  return (
                    <tr key={f._id}>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <TypeIcon type={type} />
                          <span className="fw-medium">{f.fileName}</span>
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-secondary">{type}</span>
                      </td>
                      <td className="text-end">{formatSize(f.fileSize)}</td>
                      <td className="text-end">
                        <div className="btn-group btn-group-sm">
                          <button className="btn btn-outline-secondary" title="Preview" onClick={() => onPreview(f)}><FiEye /></button>
                          <button className="btn btn-outline-secondary" title="Download" onClick={() => onDownload(f)}><FiDownload /></button>
                          <button className="btn btn-outline-info" title="Edit" onClick={() => onEdit(f)}>Edit</button>
                          {/* <button className="btn btn-outline-danger" title="Delete" onClick={() => onDelete(f)}><FiTrash2 /></button> */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

